module.exports = __webpack_public_path__ + "static/media/55_000023.f46e887e.jpg";